import React from "react";
import { FaMedal, FaTrophy } from "react-icons/fa";

import { getAdherentName, getGroupNames } from "../utils/coachStatsUtils";

function TopJudokasTable({ summaries = [] }) {
  return (
    <section className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20">
      <div className="border-b border-slate-200 p-5 dark:border-white/10">
        <p className="text-xs font-bold uppercase tracking-[0.14em] text-sky-700 dark:text-sky-200">
          Classement interne
        </p>

        <h2 className="mt-2 font-titre text-2xl font-bold text-slate-950 dark:text-white">
          Top judokas
        </h2>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full min-w-[780px] text-left">
          <thead>
            <tr className="border-b border-slate-200 bg-slate-50 text-[11px] font-bold uppercase tracking-[0.14em] text-slate-400 dark:border-white/10 dark:bg-white/[0.03]">
              <th className="px-4 py-3">Judoka</th>
              <th className="px-4 py-3">Groupe</th>
              <th className="px-4 py-3">Participations</th>
              <th className="px-4 py-3">Combats</th>
              <th className="px-4 py-3">Victoires</th>
              <th className="px-4 py-3">Podiums</th>
              <th className="px-4 py-3">Taux</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-slate-100 dark:divide-white/10">
            {summaries.slice(0, 12).map((summary, index) => (
              <tr
                key={summary.adherent.id}
                className="text-sm transition hover:bg-sky-50/60 dark:hover:bg-white/[0.03]"
              >
                <td className="px-4 py-3">
                  <div className="flex min-w-[210px] items-center gap-3">
                    <div
                      className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl ${
                        index < 3
                          ? "bg-amber-100 text-amber-700 dark:bg-amber-500/10 dark:text-amber-200"
                          : "bg-slate-100 text-slate-500 dark:bg-white/10 dark:text-white/60"
                      }`}
                    >
                      {index < 3 ? <FaTrophy /> : <FaMedal />}
                    </div>

                    <div>
                      <p className="font-bold text-slate-950 dark:text-white">
                        {getAdherentName(summary.adherent)}
                      </p>
                      <p className="text-xs font-semibold text-slate-400">
                        Rang #{index + 1}
                      </p>
                    </div>
                  </div>
                </td>

                <td className="max-w-[220px] px-4 py-3 text-xs font-bold text-slate-500 dark:text-white/50">
                  {getGroupNames(summary.adherent)}
                </td>

                <td className="px-4 py-3 font-bold text-slate-700 dark:text-white/70">
                  {summary.participations}
                </td>

                <td className="px-4 py-3 font-bold text-slate-700 dark:text-white/70">
                  {summary.totalCombats}
                </td>

                <td className="px-4 py-3">
                  <span className="rounded-full bg-emerald-100 px-3 py-1 text-xs font-bold text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-200">
                    {summary.wins}
                  </span>
                </td>

                <td className="px-4 py-3">
                  <span className="rounded-full bg-amber-100 px-3 py-1 text-xs font-bold text-amber-700 dark:bg-amber-500/10 dark:text-amber-200">
                    {summary.podiums}
                  </span>
                </td>

                <td className="px-4 py-3">
                  <span className="rounded-full bg-sky-100 px-3 py-1 text-xs font-bold text-sky-700 dark:bg-sky-500/10 dark:text-sky-200">
                    {summary.victoryRate}%
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {!summaries.length && (
        <div className="p-8 text-center text-sm font-bold text-slate-400">
          Aucun judoka à afficher.
        </div>
      )}
    </section>
  );
}

export default TopJudokasTable;